import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { websiteDetail } from "../../utils/common.data";
import Loader from "../loader";
import "./payment.css";
import { postRazorpayPaymentVerify } from "../../utils/api.functions";

const PaymentComponent = (props) => {
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadRazorpayScript = () => {
      return new Promise((resolve) => {
        const script = document.createElement("script");
        script.src = "https://checkout.razorpay.com/v1/checkout.js";
        script.onload = () => {
          setIsLoading(false);
          resolve(true);
        };
        script.onerror = () => {
          setError("Failed to load Razorpay SDK");
          resolve(false);
        };
        document.body.appendChild(script);
      });
    };

    loadRazorpayScript();
  }, []);

  const handlePayment = () => {
    const options = {
      key: props?.keyValue?.razor_key_id, // Razorpay test key
      currency: "INR",
      name: websiteDetail.titleValue,
      description: websiteDetail.paymentDescription,
      order_id: props.orderID, // This should be generated on your server
      handler: function (response) {
        ////console.log(response);
        toast.success("Payment Successful!");
        //verifyPaymentOnServer(response);
        props.apiHandler(response);
      },

      prefill: {
        name: sessionStorage.getItem("name"),
        email: sessionStorage.getItem("email"),
        contact: sessionStorage.getItem("phone"),
      },
      theme: {
        color: "#F37254",
      },
    };

    const rzp = new window.Razorpay(options);
    rzp.open();
  };

  const verifyPaymentOnServer = (paymentDetails) => {
    const apikey = sessionStorage.getItem("key");
    // Call your backend API to verify the payment status
    // You should pass `paymentDetails` to the backend for verification

    // Example using fetch (replace with your actual API endpoint):
    const data = {
      razorpay_payment_id: paymentDetails.razorpay_payment_id,
      razorpay_order_id: paymentDetails.razorpay_order_id,
      razorpay_signature: paymentDetails.razorpay_signature,
    };
    postRazorpayPaymentVerify(data, apikey)
      .then((data) => {
        if (data.success) {
          alert("Payment Verified!");
        } else {
          alert("Payment Verification Failed!");
        }
      })
      .catch((error) => {
        console.error("Verification error:", error);
        alert("Error verifying payment");
      });
  };

  return (
    <div className="payment_razorpay_container_main">
      {isLoading && <Loader />}
      {error && <p>Error loading Razorpay: {error}</p>}
      <button type="button" className="common_button_border" onClick={handlePayment} disabled={isLoading}>
        Continue with Razorpay
      </button>
    </div>
  );
};

export default PaymentComponent;
